export const ConsentComponent = ({ title, description }: any) => {
  const descriptionStr = typeof description === 'object' ? Object.values(description).join(' ') : description;
  return (
    <div className="bg-whiteColor rounded-lg h-[60vh] overflow-y-auto">
      <div className="text-consentHeaderColor unSelectedSideMenu py-4  pl-4">
        {title}
      </div>
      <hr className="bg-dividerColor h-[1px] "></hr>
      <div className=" pl-3 pt-4"><div dangerouslySetInnerHTML={{ __html: descriptionStr }} /></div>
    </div>
  );
};
